import React, { useState } from "react";
import VehicleSelect from "./VehicleSelect";
import { Button, Dialog, Tooltip } from "@material-ui/core";
import { useGetClientsQuery } from 'features/clients/clientSlice';
import { useGetVehicleDetailsQuery} from 'features/vehicles/vehicleSlice';
import { selectIsAdmin } from 'features/user/userSlice';
import { useSelector } from "react-redux";
import AddActivityDialog from "features/activity/AddActivity/AddActivityDialog";
import { AddCircle } from "@material-ui/icons";

import { vendorInvoiceStyles } from '../style';


const AddActivityWrapper = ({ selectedVehicles, refetchMatchingWorkOrders }) => {
  const classes = vendorInvoiceStyles();
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [showSelectModal, setShowSelectModal] = useState(false);

  const isAdmin = useSelector(selectIsAdmin);

  const { data: vehicleDetails } =
    useGetVehicleDetailsQuery(selectedVehicle, { skip: !selectedVehicle });

  const { data: clients } =
    useGetClientsQuery(null, { skip: !isAdmin });

  const client = clients?.find(c =>
    c.clientAccounts.find(ca => ca.id === vehicleDetails?.customerId)
  );

  const validVehicles = (selectedVehicles || []).filter(v => v && v.vehicleId);

  const handleAddActivityClick = () => {
    if (!validVehicles || validVehicles.length === 0) {
      return;
    }
    if (validVehicles.length === 1) {
      setSelectedVehicle(validVehicles[0].vehicleId);
      setOpen(true);
    } else if (validVehicles.length > 1) {
      setShowSelectModal(true);
    }
  };

  const [open, setOpen] = useState(false);

  const allSelected = validVehicles.length > 0;
  
  const tooltipMsg =
    !selectedVehicles || selectedVehicles.length === 0
      ? "A vehicle is required"
      : !allSelected
        ? "Select at least one vehicle"
        : "";

  return (
    <>
      <Tooltip
        title={tooltipMsg}
        arrow
        disableHoverListener={allSelected}
      >
        <span>
          <Button
            onClick={handleAddActivityClick}
            startIcon={<AddCircle />}
            disabled={!allSelected}
            className={classes.addActivityBtn}
          >
            Add Activity
          </Button>
        </span>
      </Tooltip>
      <Dialog open={showSelectModal} onClose={() => setShowSelectModal(false)}>
        <VehicleSelect
          vehicles={validVehicles}
          onSelect={(id) => {
            setSelectedVehicle(id);
            setShowSelectModal(false);
            setOpen(true);
          }}
          onClose={() => setShowSelectModal(false)}
        />
      </Dialog>

      {selectedVehicle && (
        <AddActivityDialog
          open={open}
          setOpen={setOpen}
          vehicleId={selectedVehicle}
          lotId={vehicleDetails?.lotId}
          clientId={client?.id}
          onClose={refetchMatchingWorkOrders}
          vehicleTypeId={vehicleDetails?.vehicleTypeId}
          entityId={client?.id}
          vehicleDetails={vehicleDetails}
        />
      )}
    </>
  );
};

export default AddActivityWrapper;
